import React from 'react'
import { rolType } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { authRolSelector, setRegisterStep, setRol } from 'src/features'
import { RegisterUserStepChanger, CustomCard, CustomRadioGroup, CustomRadio, CustomTitle } from 'src/components'

const rols = { COMPANY: 'COMPANY', INDIVIDUAL: 'INDIVIDUAL' }

const UserTypeForm: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const rol: rolType = useAppSelector(authRolSelector)

  const handleSubmitClick = () => dispatch(setRegisterStep(3))
  const changeRol = (value: rolType) => dispatch(setRol(value))

  return <div className='m-1'>
    <CustomCard>
      <CustomTitle label={t('Auth.Register.UserType')} type={null} />
      <CustomTitle label={t('Auth.Register.UserTypeLabel')} />
      <div className='mt-5'>
        <CustomRadioGroup defaultValue={rol} handleChange={changeRol}>
          <CustomRadio text={t('Auth.Register.IndividualLabel')} value={rols.INDIVIDUAL} />
          <CustomRadio text={t('Auth.Register.CompanyLabel')} value={rols.COMPANY} />
        </CustomRadioGroup>
      </div>
    </CustomCard>
    <RegisterUserStepChanger nextStepValue={3} beforeStepValue={1} handleSubmitClick={handleSubmitClick}/>
  </div>
}

export default UserTypeForm
